<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <order-state-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import OrderStateProvider from "../../../../providers/OrderStateProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import OrderStateForm from "../OrderStateForm";
    
    


    export default {
        name: "OrderStateCreate",
         
        components: { OrderStateForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'delivery.orderState.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    state: '',
                    takeAwayMessage: '',
                    deliveryMessage: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    OrderStateProvider.createOrderState(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createOrderState)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

